import NewDownload from 'src/adminPanel/entities/office/downloadManagement/NewDownload';
import NewDownloadCategory from 'src/adminPanel/entities/office/downloadManagement/NewDownloadCategory';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from '../actions';

export const FETCH_DOWNLOAD_CATEGORIES = 'FETCH_DOWNLOAD_CATEGORIES';
export const REQUEST_DOWNLOAD_CATEGORIES = 'REQUEST_DOWNLOAD_CATEGORIES';
export const SUCCESS_DOWNLOAD_CATEGORIES = 'SUCCESS_DOWNLOAD_CATEGORIES';
export const FAILURE_DOWNLOAD_CATEGORIES = 'FAILURE_DOWNLOAD_CATEGORIES';

export const fetchDownloadCategories = () => action(FETCH_DOWNLOAD_CATEGORIES);
export const requestDownloadCategories = () => action(REQUEST_DOWNLOAD_CATEGORIES);
export const requestDownloadCategoriesSuccess = (response: any) => action(SUCCESS_DOWNLOAD_CATEGORIES, { response });
export const requestDownloadCategoriesFailure = (error: any) => action(FAILURE_DOWNLOAD_CATEGORIES, { error });

export const CREATE_DOWNLOAD_CATEGORY = 'CREATE_DOWNLOAD_CATEGORY';
export const REQUEST_CREATE_DOWNLOAD_CATEGORY = 'REQUEST_CREATE_DOWNLOAD_CATEGORY';
export const SUCCESS_CREATE_DOWNLOAD_CATEGORY = 'SUCCESS_CREATE_DOWNLOAD_CATEGORY';
export const FAILURE_CREATE_DOWNLOAD_CATEGORY = 'FAILURE_CREATE_DOWNLOAD_CATEGORY';

export const createDownloadCategory = (newDownloadCategory: NewDownloadCategory) =>
    action(CREATE_DOWNLOAD_CATEGORY, { newDownloadCategory });
export const requestCreateDownloadCategory = () => action(REQUEST_CREATE_DOWNLOAD_CATEGORY);
export const requestCreateDownloadCategorySuccess = (response: any) =>
    action(SUCCESS_CREATE_DOWNLOAD_CATEGORY, { response });
export const requestCreateDownloadCategoryFailure = (error: any) => action(FAILURE_CREATE_DOWNLOAD_CATEGORY, { error });

export const EDIT_DOWNLOAD_CATEGORY = 'EDIT_DOWNLOAD_CATEGORY';
export const REQUEST_EDIT_DOWNLOAD_CATEGORY = 'REQUEST_EDIT_DOWNLOAD_CATEGORY';
export const SUCCESS_EDIT_DOWNLOAD_CATEGORY = 'SUCCESS_EDIT_DOWNLOAD_CATEGORY';
export const FAILURE_EDIT_DOWNLOAD_CATEGORY = 'FAILURE_EDIT_DOWNLOAD_CATEGORY';

export const editDownloadCategory = (newDownloadCategory: NewDownloadCategory) =>
    action(EDIT_DOWNLOAD_CATEGORY, { newDownloadCategory });
export const requestEditDownloadCategory = () => action(REQUEST_EDIT_DOWNLOAD_CATEGORY);
export const requestEditDownloadCategorySuccess = (response: any) =>
    action(SUCCESS_EDIT_DOWNLOAD_CATEGORY, { response });
export const requestEditDownloadCategoryFailure = (error: any) => action(FAILURE_EDIT_DOWNLOAD_CATEGORY, { error });

export const DELETE_DOWNLOAD_CATEGORY = 'DELETE_DOWNLOAD_CATEGROY';
export const REQUEST_DELETE_DOWNLOAD_CATEGORY = 'REQUEST_DELETE_DOWNLOAD_CATEGORY';
export const SUCCESS_DELETE_DOWNLOAD_CATEGORY = 'SUCCESS_DELETE_DOWNLOAD_CATEGORY';
export const FAILURE_DELETE_DOWNLOAD_CATEGORY = 'FAILURE_DELETE_DOWNLOAD_CATEGORY';

export const deleteDownloadCategoryById = (downloadCategoryId: string) =>
    action(DELETE_DOWNLOAD_CATEGORY, { downloadCategoryId });
export const requestDeleteDownloadCategoryById = () => action(REQUEST_DELETE_DOWNLOAD_CATEGORY);
export const requestDeleteDownloadCategoryByIdSuccess = (response: any) =>
    action(SUCCESS_DELETE_DOWNLOAD_CATEGORY, { response });
export const requestDeleteDownloadCategoryByIdFailure = (error: any) =>
    action(FAILURE_DELETE_DOWNLOAD_CATEGORY, { error });

export const FETCH_DOWNLOADS = 'FETCH_DOWNLOADS';
export const REQUEST_DOWNLOADS = 'REQUEST_DOWNLOADS';
export const SUCCESS_DOWNLOADS = 'SUCCESS_DOWNLOADS';
export const FAILURE_DOWNLOADS = 'FAILURE_DOWNLOADS';

export const fetchDownloads = (downloadCategoryNormalizedName: string, pageable?: PageableQueryParams) =>
    action(FETCH_DOWNLOADS, { downloadCategoryNormalizedName, pageable });
export const requestDownloads = () => action(REQUEST_DOWNLOADS);
export const requestDownloadsSuccess = (response: any) => action(SUCCESS_DOWNLOADS, { response });
export const requestDownloadsFailure = (error: any) => action(FAILURE_DOWNLOADS, { error });

export const CREATE_DOWNLOAD = 'CREATE_DOWNLOAD';
export const REQUEST_CREATE_DOWNLOAD = 'REQUEST_CREATE_DOWNLOAD';
export const SUCCESS_CREATE_DOWNLOAD = 'SUCCESS_CREATE_DOWNLOAD';
export const FAILURE_CREATE_DOWNLOAD = 'FAILURE_CREATE_DOWNLOAD';

export const createDownload = (newDownload: NewDownload) => action(CREATE_DOWNLOAD, { newDownload });
export const requestCreateDownload = () => action(REQUEST_CREATE_DOWNLOAD);
export const requestCreateDownloadSuccess = (response: any) => action(SUCCESS_CREATE_DOWNLOAD, { response });
export const requestCreateDownloadFailure = (error: any) => action(FAILURE_CREATE_DOWNLOAD, { error });

export const UPDATE_DOWNLOAD = 'UPDATE_DOWNLOAD';
export const REQUEST_UPDATE_DOWNLOAD = 'REQUEST_UPDATE_DOWNLOAD';
export const SUCCESS_UPDATE_DOWNLOAD = 'SUCCESS_UPDATE_DOWNLOAD';
export const FAILURE_UPDATE_DOWNLOAD = 'FAILURE_UPDATE_DOWNLOAD';

export const updateDownload = (newDownload: NewDownload) => action(UPDATE_DOWNLOAD, { newDownload });
export const requestUpdateDownload = () => action(REQUEST_UPDATE_DOWNLOAD);
export const requestUpdateDownloadSuccess = (response: any) => action(SUCCESS_UPDATE_DOWNLOAD, { response });
export const requestUpdateDownloadFailure = (error: any) => action(FAILURE_UPDATE_DOWNLOAD, { error });

export const DELETE_DOWNLOAD = 'DELETE_DOWNLOAD';
export const REQUEST_DELETE_DOWNLOAD = 'REQUEST_DELETE_DOWNLOAD';
export const SUCCESS_DELETE_DOWNLOAD = 'SUCCESS_DELETE_DOWNLOAD';
export const FAILURE_DELETE_DOWNLOAD = 'FAILURE_DELETE_DOWNLOAD';

export const deleteDownloadById = (downloadId: string) => action(DELETE_DOWNLOAD, { downloadId });
export const requestDeleteDownload = () => action(REQUEST_DELETE_DOWNLOAD);
export const requestDeleteDownloadSuccess = (response: any) => action(SUCCESS_DELETE_DOWNLOAD, { response });
export const requestDeleteDownloadFailure = (error: any) => action(FAILURE_DELETE_DOWNLOAD, { error });

export const FETCH_DOWNLOAD_LANGUAGE = 'FETCH_DOWNLOAD_LANGUAGE';
export const REQUEST_DOWNLOAD_LANGUAGE = 'REQUEST_DOWNLOAD_LANGUAGE';
export const SUCCESS_DOWNLOAD_LANGUAGE = 'SUCCESS_DOWNLOAD_LANGUAGE';
export const FAILURE_DOWNLOAD_LANGUAGE = 'FAILURE_DOWNLOAD_LANGUAGE';

export const fetchDownloadLanguage = () => action(FETCH_DOWNLOAD_LANGUAGE);
export const requestDownloadLanguage = () => action(REQUEST_DOWNLOAD_LANGUAGE);
export const requestDownloadLanguageSuccess = (response: any) => action(SUCCESS_DOWNLOAD_LANGUAGE, { response });
export const requestDownloadLanguageFailure = (error: any) => action(FAILURE_DOWNLOAD_LANGUAGE, { error });

export const CREATE_DOWNLOAD_LANGUAGE = 'CREATE_DOWNLOAD_LANGUAGE';
export const REQUEST_CREATE_DOWNLOAD_LANGUAGE = 'REQUEST_CREATE_DOWNLOAD_LANGUAGE';
export const SUCCESS_CREATE_DOWNLOAD_LANGUAGE = 'SUCCESS_CREATE_DOWNLOAD_LANGUAGE';
export const FAILURE_CREATE_DOWNLOAD_LANGUAGE = 'FAILURE_CREATE_DOWNLOAD_LANGUAGE';

export const createDownloadLanguage = (downloadId: string, languageIso2: string, file: any, countryIso2?: string) =>
    action(CREATE_DOWNLOAD_LANGUAGE, { downloadId, languageIso2, file, countryIso2 });
export const requestCreateDownloadLanguage = () => action(REQUEST_CREATE_DOWNLOAD_LANGUAGE);
export const requestCreateDownloadLanguageSuccess = (response: any) =>
    action(SUCCESS_CREATE_DOWNLOAD_LANGUAGE, { response });
export const requestCreateDownloadLanguageFailure = (error: any) => action(FAILURE_CREATE_DOWNLOAD_LANGUAGE, { error });

export const DELETE_DOWNLOAD_LANGUAGE = 'DELETE_DOWNLOAD_LANGUAGE';
export const REQUEST_DELETE_DOWNLOAD_LANGUAGE = 'REQUEST_DELETE_DOWNLOAD_LANGUAGE';
export const SUCCESS_DELETE_DOWNLOAD_LANGUAGE = 'SUCCESS_DELETE_DOWNLOAD_CATEGORY';
export const FAILURE_DELETE_DOWNLOAD_LANGUAGE = 'FAILURE_DELETE_DOWNLOAD_CATEGORY';

export const deleteDownloadLanguageById = (downloadLanguageId: string) =>
    action(DELETE_DOWNLOAD_LANGUAGE, { downloadLanguageId });
export const requestDeleteDownloadLanguageById = () => action(REQUEST_DELETE_DOWNLOAD_LANGUAGE);
export const requestDeleteDownloadLanguageByIdSuccess = (response: any) =>
    action(SUCCESS_DELETE_DOWNLOAD_LANGUAGE, { response });
export const requestDeleteDownloadLanguageByIdFailure = (error: any) =>
    action(FAILURE_DELETE_DOWNLOAD_LANGUAGE, { error });
